var vex = require('vex-js');
vex.registerPlugin(require('vex-dialog'));
require('../../node_modules/vex-js/dist/css/vex.css');

jQuery(document).ready(function () {
    jQuery('[data-trigger-login-modal]').click(function(){
        var $launcher = jQuery(this);
        vex.dialog.open({
            contentClassName: 'user-modal',
            showCloseButton: true,
            unsafeMessage:[
                '<h2 class="vex__title">' + window.translate.t('userlogin.title') + '</h2>',
                '<p>' + window.translate.t('userlogin.content')+'</p>'
            ].join(''),
            buttons: [
                jQuery.extend({}, vex.dialog.buttons.YES, { text: window.translate.t('userlogin.create-button'), click: function(){
                    if ($launcher.attr('data-trigger-login-modal')) {
                        window.location.href = window.appUrls.signUp + '?redirect=' + encodeURI($launcher.attr('data-trigger-login-modal'));
                    } else {
                        window.location.href = window.appUrls.signUp ;
                    }
                } }),
                jQuery.extend({}, vex.dialog.buttons.NO, {text: window.translate.t('userlogin.signin-button'), click: function () {
                    if ($launcher.attr('data-trigger-login-modal')) {
                        window.location.href = window.appUrls.logIn + '?redirect=' + encodeURI($launcher.attr('data-trigger-login-modal'));
                    } else {
                        window.location.href = window.appUrls.logIn;
                    }
                    } })
            ]
        });
        return false;
    });
});